import { useSelector } from 'react-redux'
import { useGetTimesheetsFilteredQuery as useGetTimesheetsFilteredQueryRTK } from '../../store/api/timesheet/timesheetApi'
import { TimesheetStoreState } from '../../store/timesheetStore'
import { useShouldSkipFilteredQuery } from './useShouldSkipFilteredQuery'

export const useGetTimesheetsFilteredQuery = () => {
 const timesheetDetails = useSelector((state: TimesheetStoreState) => state.timesheetDetails)
  const shouldSkipFilteredQuery = useShouldSkipFilteredQuery()
  const { data, isLoading, error, refetch, isFetching, isError } = useGetTimesheetsFilteredQueryRTK(timesheetDetails?.filters, {
    skip: shouldSkipFilteredQuery,
  })
  return { data, isLoading, error, refetch, isFetching, isError }
}